export default {"src":"/_next/static/media/accounting-logo.97fb2b7b.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};